import { useEffect, useState, useContext, useRef } from 'react';
import { useIntl } from 'react-intl';
import styles from './index.less';
import { Typography } from 'iglooform';
import { getCustomersList } from './service';
import Context from '@/utils/context';
import { handleOnScroll } from '@/utils/common';
import CustomerList from '@/components/customer-list';
import EmptyView from '@/components/empty-view/empty-view';
import SkeletonLoading from '@/components/skeleton-loading';

const Customers = () => {
  const [customersList, setCustomersList] = useState<CustomerListType>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { isPc } = useContext(Context);
  const cursor = useRef('0'); // 分页游标
  const { formatMessage } = useIntl();

  const getDataList = (isScroll: boolean) => {
    if (cursor.current === '') return;
    if (window.location.pathname !== '/customers') return;
    if (cursor.current === '0' && isScroll) return;
    getCustomersList({ cursor: cursor.current, size: 20 })
      .then((res: CustomerList) => {
        if (res) {
          if (cursor.current === '0') {
            setCustomersList(res.list);
          } else {
            if (res.list) {
              setCustomersList((newList) => [...newList, ...res.list]);
            }
          }
          cursor.current = res.cursor;
        }
      })
      .finally(() => {
        window.removeEventListener(
          'scroll',
          handleOnScroll(() => getDataList(true)),
        );
        setLoading(true);
      });
  };

  useEffect(() => {
    window.addEventListener(
      'scroll',
      handleOnScroll(() => getDataList(true)),
    );
    return () =>
      window.removeEventListener(
        'scroll',
        handleOnScroll(() => getDataList(true)),
      );
  }, []);

  useEffect(() => {
    getDataList(false);
  }, []);

  return (
    <>
      {loading ? (
        <div className={isPc ? styles.customerLayout : styles.customerLayoutH5}>
          <div className={styles.customerLayoutCenter}>
            {isPc ? (
              <div className={styles.titleButtonBox}>
                <div className={styles.title}>
                  <Typography level="h2">
                    {formatMessage({ id: 'Customer List' })}
                  </Typography>
                </div>
              </div>
            ) : (
              <div className={styles.titleButtonBox}>
                <div className={styles.title}>
                  <Typography level="h2">
                    {formatMessage({ id: 'Customer List' })}
                  </Typography>
                </div>
              </div>
            )}
            {customersList && !!customersList.length ? (
              <CustomerList list={customersList} isPc={isPc} />
            ) : (
              <EmptyView
                text={formatMessage({ id: 'You have no customer now.' })}
              />
            )}
          </div>
        </div>
      ) : (
        <div style={{ marginTop: '100px' }}>
          <SkeletonLoading />
        </div>
      )}
    </>
  );
};

export default Customers;
